import React, { useEffect, useMemo, useState } from 'react';
import { apiCall } from '../../utils/apiService';
import { getApiDisplayBase } from '../../utils/apiDisplayBase';
import { buildSendTextApiExamples } from './messageApiExampleBuilders';
import MessageApiExamplesPanel from './MessageApiExamplesPanel';
import MessageHeaderLayer from './MessageHeaderLayer';

const SingleLayer = () => {
  const [clientID, setClientId] = useState('');
  const [templates, setTemplates] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
  const [spinner, setSpinner] = useState(false);
  const [data, setData] = useState({
    client_id: null,
    content: { text: "" },
    fromTemplet: false,
    token: null,
    message: null,
    name: null,
    mobile: null,
    onlySave: false,
    saveAsTemplet: false,
    type: "text"
  });

  const fetchTemplates = async (type) => {
    try {
      const response = await apiCall({
        url: `templet/get-templet`,
        method: 'POST',
        body: { type: type }
      });
      setTemplates(response.data);
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  // send single message code
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { isValid, messageText } = validated();
    if (isValid) {
      setSpinner(true);
      try {
        const response = await apiCall({
          url: 'send-message/send',
          method: 'POST',
          body: data,
        });

        setAlertMessage({ message: response.msg, class: 'success' });
        if (response.success) {
          if (response.template) {
            addNewTemplate(response.template);
          }
          cleanForm()
        }

      } catch (error) {
        setAlertMessage({ message: error.message, class: 'danger' });
        console.error('Login error:', error);
        hideAlert(2);
      }
    } else {
      setAlertMessage({ message: messageText, class: 'danger' });
      hideAlert(2);
    }
  };

  // validate form
  const validated = () => {
    console.log(data.fromTemplet)
    if (data.client_id == '' || data.client_id == null) {
      return { isValid: false, messageText: 'Instance is required!' };
    } else if (data.token == '' || data.token == null) {
      return { isValid: false, messageText: 'Token is required!' };
    } else if (data.mobile == '' || data.mobile == null) {
      return { isValid: false, messageText: 'Phone is required!' };
    } else if (data.fromTemplet && data.content.text == '') {
      return { isValid: false, messageText: 'Template is required!' };
    } else if (data.message == '' || data.message == null) {
      return { isValid: false, messageText: 'Message is required!' };
    } else if (data.saveAsTemplet && (data.name == '' || data.name == null)) {
      return { isValid: false, messageText: 'Template name is required!' };
    }
    return { isValid: true, messageText: '' }
  }

  // after submission form will be cleared
  const cleanForm = () => {
    // setData({
    //   content: { text: "" },
    //   fromTemplet: false,
    //   message: null,
    //   name: null,
    //   mobile: null,
    //   onlySave: false,
    //   saveAsTemplet: false,
    //   type: "text"
    // });
    setSpinner(false);
    hideAlert(2);
  }

  // hide alert after few seconds
  const hideAlert = (sec = 1) => {
    setTimeout(() => {
      setAlertMessage('');
      setSpinner(false);
    }, (sec * 1000));
  }

  // add new template into the existing list
  const addNewTemplate = (newTemplate) => {
    setTemplates([newTemplate, ...templates]);
  };

  useEffect(() => {
    fetchTemplates('text');
  }, []);

  const apiBase = getApiDisplayBase();
  const codeExamples = useMemo(() => buildSendTextApiExamples(apiBase), [apiBase]);

  return (
    <>
      <div className='card'>
        <div className="card-body">
          <MessageHeaderLayer getHeaderData={(id, apiKey) => setData({ ...data, client_id: id, token: apiKey })} />
          <div className="row g-0">
            <div className="col-md-6 mt-3 pe-md-3">
              <form className='border rounded' onSubmit={handleSubmit}>
                <div className='p-3 text-white' style={{ borderTopLeftRadius: '5px', borderTopRightRadius: '5px', background: '#26a69a' }}>
                  Request test
                </div>
                <div className="row m-0 g-0 p-3">
                  <div className="alert alert-success" style={{ fontSize: '12px' }}>
                    Note: Use it wisely, not recommended to check bulk numbers
                  </div>
                  {
                    alertMessage && (
                      <div className={`alert alert-${alertMessage.class}`} style={{ fontSize: '12px' }}>
                        {alertMessage.message}
                      </div>
                    )
                  }
                  <input type='number' className="form-control" placeholder='Phone: 923037900571' value={data.mobile} onChange={(e) => setData({ ...data, mobile: e.target.value })} />
                  <span style={{ fontSize: '10px', color: 'gray' }}>Mobile number with country code without +</span>
                  <div className="d-flex align-items-center ">
                    <div className="form-switch switch-success d-flex align-items-center gap-3 my-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="switch4"
                        checked={data.fromTemplet}
                        onChange={(e) =>
                          setData({ ...data, fromTemplet: e.target.checked, saveAsTemplet: false })
                        }
                      />
                      <label
                        className="form-check-label line-height-1 fw-medium text-secondary-light"
                        htmlFor="switch4"
                      >
                        Using template?
                      </label>
                    </div>
                  </div>
                  {!data.fromTemplet && (
                    <>
                      <textarea rows={5} className="form-control" placeholder='Type message here...' onChange={(e) => setData({ ...data, message: e.target.value, content: { ...data.content, text: e.target.value } })}>{data.message}</textarea>
                      <div className="d-flex align-items-center ">
                        <div className="form-switch switch-success d-flex align-items-center gap-3 my-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch3"
                            defaultChecked={true}
                            checked={data.saveAsTemplet}
                            onChange={(e) => setData({ ...data, saveAsTemplet: !data.saveAsTemplet })}
                          />
                          <label
                            className="form-check-label line-height-1 fw-medium text-secondary-light"
                            htmlFor="switch3"
                          >
                            Save as template?
                          </label>
                        </div>
                      </div>
                      {
                        data.saveAsTemplet && (
                          <>
                            <input type="text" className="form-control" value={data.name} onChange={(e) => setData({ ...data, name: e.target.value })} placeholder='Template name' />
                            <div className="d-flex align-items-center mt-3">
                              <input
                                className="form-check-input mt-0"
                                type="checkbox"
                                id="checkbox1"
                                defaultChecked={true}
                                checked={data.onlySave}
                                onChange={(e) => setData({ ...data, onlySave: !data.onlySave })}
                              />
                              <label
                                className="form-check-label line-height-3 ms-3 fw-medium text-secondary-light"
                                htmlFor="checkbox1" style={{ fontSize: '14px' }}
                              >
                                Do not send WhatsApp message save template only.
                              </label>
                            </div>
                          </>
                        )
                      }
                    </>
                  )}
                  {
                    data.fromTemplet && (
                      <div className="form-group">
                        <select name="" id="" className="form-select bg-white" onChange={(e) => setData({ ...data, message: e.target.value, content: { ...data.content, text: e.target.value } })}>
                          <option value="1" disabled selected>
                            Select Template
                          </option>
                          {templates.length > 0 &&
                            templates.map((template) => (
                              <option key={template.id} value={JSON.parse(template.content).text}>
                                {template.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    )
                  }
                  <div className='d-flex justify-content-center mt-3'>
                    <button type='submit' className='btn btn-success' style={{ background: '#26a69a'  }}>Send Message</button>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-md-6 mt-3 ps-md-3">
              <MessageApiExamplesPanel examples={codeExamples} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SingleLayer